import { render, staticRenderFns } from "./ProductCardProfessionalPromo1.vue?vue&type=template&id=9636248e&scoped=true&"
import script from "./ProductCardProfessionalPromo1.vue?vue&type=script&lang=ts&"
export * from "./ProductCardProfessionalPromo1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9636248e",
  null
  
)

export default component.exports